export const SHEET_ID =
  import.meta.env.VITE_SHEET_ID || '13zEBBQltj9vObCI7VXudjnghDVW3yXoXRC7hLQMPAe0';

export const APPS_SCRIPT_URL = import.meta.env.VITE_APPS_SCRIPT_URL || '';
export const ADMIN_TOKEN = import.meta.env.VITE_ADMIN_TOKEN || '';

export const COLS = [
  'STATUS', 'NOMBRE', 'FECHA', 'NUMERO', 'PAGO RECIBIDO',
  'BANCO', 'AD ID', 'EMAIL', 'POST ID',
];

export const AUTO_REFRESH_MS = 15000;
export const PAGE_SIZE = 25;
